import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FiveSectionStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';

const styles = require('./index.less');

/**
 * FiveSection
 * @param store {FiveSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FiveSection = ({ store }) => {
  store.use();

  return (
    <div
      className={cx(styles.fiveSectionRoot, store.isActive && styles.rootActive)}
      onClick={e => {
        e.stopPropagation();
        store.isTouch = false;
      }}
    >
      <div className={cx(styles.fiveBox)}>
        {/*  style={{ top: `${px2rem(store.vhOffset > 0 ? 162 - store.vhOffset : 162)}rem` }} */}
        <div className={cx(styles.title)} />

        {/* <div className={styles.icon} /> */}

        {/* style={{ top: `${px2rem(store.vhOffset > 0 ? -store.vhOffset : 0)}rem` }} */}
        <div className={cx(styles.content)}>
          <Link className={cx(styles.btn, styles.equipment1)}>
            <div
              className={styles.triggerArea}
              onClick={() => {
                store.currentIndexChange(0);
              }}
            />
          </Link>
          <Link className={cx(styles.btn, styles.equipment2)}>
            <div
              className={styles.triggerArea}
              onClick={() => {
                store.currentIndexChange(1);
              }}
            />
          </Link>
          <Link className={cx(styles.btn, styles.equipment3)}>
            <div
              className={styles.triggerArea}
              onClick={() => {
                store.currentIndexChange(2);
              }}
            />
          </Link>
          <Link className={cx(styles.btn, styles.equipment4)}>
            <div
              className={styles.triggerArea}
              onClick={() => {
                store.currentIndexChange(3);
              }}
            />
          </Link>
          <Link className={cx(styles.btn, styles.equipment5)}>
            <div
              className={styles.triggerArea}
              onClick={() => {
                store.currentIndexChange(4);
              }}
            />
          </Link>
          <Link className={cx(styles.btn, styles.equipment6)}>
            <div
              className={styles.triggerArea}
              onClick={() => {
                store.currentIndexChange(5);
              }}
            />
          </Link>

          <div className={cx(styles.roulette)} />
          {/* <div className={cx(styles.roulette_icon)} /> */}
          {store.coordinateList?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {store.currentIndex === index && (
                  <div className={cx(styles.highlight_mask, styles['highlight_mask' + store.currentIndex])} style={{ backgroundImage: `url(${item.imgOn})` }} />
                )}
                {store.currentIndex === index && (
                  <div className={styles.textContent} style={{ zIndex: store.isTouch && 100 }}>
                    <div className={styles.maskCenter} />
                    <img className={styles.img} src={item.imgCenter} alt="" />
                    <div className={styles.name}>{item.id}</div>

                    <div
                      className={cx(styles.text)}
                      id="pullText"
                      onClick={e => {
                        e.stopPropagation();
                        store.isTouch = true;
                      }}
                    >
                      {item.text}
                    </div>
                    <div className={cx(!store.isTouch ? styles.textBoxNone : styles.textBox)} id="text_Box">
                      <div>{item.text}</div>
                    </div>
                    <div className={styles.pull_downButton} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FiveSection, FiveSectionStore);
